import React, { useContext } from "react";
import { ContextNotificacoes } from "../../services/notificacoes";
import { ReactComponent as NotificacaoErro } from "../../assets/novosicones/notificacoes/notificacao_erro.svg";
import { ReactComponent as CloseError } from "../../assets/novosicones/notificacoes/close.svg";
const NotificationErrorModal = () => {
  const { setNotificationNotFoundError } = useContext(ContextNotificacoes);

  return (
    <div
      className="centralized-space-between container"
      style={{
        backgroundColor: "#b61817",
        padding: "16px 16px",
        borderRadius: "4px",
        marginBottom: "25px",
        marginTop: "-25px",
        zIndex: "999",
        color: "#ffffff",
      }}
    >
      <div className="centralized">
        <NotificacaoErro
          style={{ fill: "#ffffff", marginRight: "16px", fontSize: "14px" }}
        />{" "}
        O item selecionado não está disponível
      </div>

      <button
        onClick={() => {
          setNotificationNotFoundError(false);
        }}
        style={{
          cursor: "pointer",
          backgroundColor: "transparent",
          border: "none",
        }}
      >
        <CloseError />
      </button>
    </div>
  );
};

export default NotificationErrorModal;
